import { render } from "./LoaderView.vue?vue&type=template&id=6f277e77&scoped=true"
import script from "./LoaderView.vue?vue&type=script&lang=js"
export * from "./LoaderView.vue?vue&type=script&lang=js"

import "./LoaderView.vue?vue&type=style&index=0&id=6f277e77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f277e77"]])

export default __exports__